import ResponsiveImage from '../responsive-image';
import Link from 'next/link';

const JobsThatScale = () => {
  return (
    <>
      <div className="py-5 background-white">
        <div className="container-xl">
          <div className="p-5 background-red text-center">
            <div className="row justify-content-center">
              <div className="col-sm-9">
                <h2 className="text-white">
                  JobsThatScale<sup>&trade;</sup>
                </h2>
                <p className="mb-5 text-white">
                  Our cost-per-click job posting solution for high volume hiring employers who need
                  to hire the highest quality, early career candidates faster and at the lowest
                  cost.
                </p>

                <p className="mb-5 fs-4 text-white legend">
                  <strong className="background-red">How it Works</strong>
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <ResponsiveImage
                  src="/images/icon-assessment.png"
                  alt="Needs Assessment icon"
                  className="mb-4"
                />
                <p className="mb-3 fs-5 text-white">Needs Assessment</p>
                <p className="text-white">First, we listen so that we understand your needs.</p>
              </div>
              <div className="col-md-4 mb-3">
                <ResponsiveImage
                  src="/images/icon-calculate.png"
                  alt="Calculate icon"
                  className="mb-4"
                />
                <p className="mb-3 fs-5 text-white">Calculate</p>
                <p className="text-white">
                  Then, we calculate the number of quality candidates you need to meet your hiring
                  goal.
                </p>
              </div>
              <div className="col-md-4 mb-3">
                <ResponsiveImage
                  src="/images/icon-save.png"
                  alt="Save Money icon"
                  className="mb-4"
                />
                <p className="mb-3 fs-5 text-white">Save Money</p>
                <p className="text-white">
                  Instead of paying by the number of postings, you pay only for the candidates who
                  click to your site to apply.
                </p>
              </div>
            </div>

            <Link href="/employers#JobsThatScale" passHref>
              <a className="text-btn outline mb-5">
                Get the JobsThatScale<sup>&trade;</sup> Package
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobsThatScale;
